import React from 'react'
import { IconButton, Paragraph } from '@fs/zion-ui'
import { ArrowCaret } from '@fs/zion-icon'
import { useTranslation } from 'react-i18next'
import { navButtonCss } from '../navigationButtonNo/NavigationButtonNo'

export default function NavigationButtonUnsure({ onClick, loading, linkName = '' }) {
  const { t } = useTranslation()
  return (
    <div css={navButtonCss()}>
      <IconButton
        data-testid="review-experience-navigation-button-unsure"
        title={t('full-name-correction.step-one-unsure', 'Unsure')}
        Icon={ArrowCaret}
        onClick={onClick}
        color="blue"
        emphasis="lightHigh"
        size="lg"
        disabled={loading}
        linkName={linkName}
      />
      <Paragraph size="sm" centered>
        {t('full-name-correction.step-one-unsure', 'Unsure')}
      </Paragraph>
    </div>
  )
}
